<template>
    <div class="body">
        <p  class="font1" style="padding-top: 13vh;">愿将腹中饮绿水</p>
        <p  class="font1" style="padding-top: 1vh;">不辞长作岭头人</p>

        <p class="font2" style="padding-top: 7vh;">2023年您的线下授课时数共计<a class="font3">{{ this.totalHours }}</a>小时：</p>

        <p class="font2" style="padding-top: 2vh;"  v-for="(char, index) in lessonArray" :key="index">
            <a class="font3">{{ char.class_type }}</a>类课程
            <a class="font3">{{ char.class_num }}</a>门
            <a class="font3">{{ char.hours }}</a>小时，
            <a class="font3">{{ char.student_num }}</a>人参与
        </p>
    </div>
</template>
  
<script>
import AddNumber from './AddNumber.vue';
export default {
    components:{AddNumber},
    props: ["ReportData"],
    data(){
        return{
            lessonArray:[],
            totalHours:0,
            classType:'',
            sutdentNum:0,
        }
    },
    created() {
        this.lessonArray = JSON.parse(this.ReportData.lesson)
        // console.log(this.lessonArray,'课程')
        this.lessonArray.forEach(element => {
        this.totalHours+=parseInt(element.hours)
        });
    }
}
</script>
  
<style scoped>
.body {
    background:url("../../assets/year23/bg3.jpg")  no-repeat;
    background-size: 100% 100%,cover;
    width: 100%;
    height: 100vh;
    display: flex;
    flex-direction: column;  
    align-items: center;  
}
.font1 {
    width: 80%;
    margin: 0 auto;
    text-align: center;
    font-size: 20px;
    color: #fff;
    font-weight: bold;
    font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
}
.font2 { 
    width: 80%;
    margin: 0 auto;
    padding: 0;
    color: #fff;
    font-size: 17px;
    font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
}
.font3 {
    font-size: 18px;
    font-weight: bold;
    color: #953b5d;
    text-shadow:  -1px -1px 0 #fff, 1px -1px 0 #fff, -1px 1px 0 #fff, 1px 1px 0 #fff;
    font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
}
.AddNumber-com {
    font-size: 20px;
    font-weight: bold;
    color: orange;
}
  </style>